const DEFAULT_LANGUAGE = 'he';

const languages = {
  he: { dir: 'rtl', prefix: '' },
  en: { dir: 'ltr', prefix: '/en' },
};

const PREFIX_REGEX = /^\/en(?=\/|$)/;

/**
 * get language by url pathname
 * @param {string} pathname
 * @returns {string} language code
 */
const getLanguageFromPath = (pathname = '') => (PREFIX_REGEX.test(pathname) ? 'en' : DEFAULT_LANGUAGE);

/**
 * remove language prefix from pathname
 * @param {string} pathname
 * @returns {string} pathname without language prefix
 */
const stripLanguagePrefix = (pathname = '') => pathname.replace(PREFIX_REGEX, '') || '/';

/**
 * add language prefix to path
 * @param {string} path
 * @param {string} lng
 * @returns {string} path with language prefix
 */
const localizePath = (path = '/', lng = DEFAULT_LANGUAGE) => {
  const { prefix } = languages[lng] || languages[DEFAULT_LANGUAGE];

  if (!prefix) return path;

  return (path === '/') ? prefix : `${prefix}${path}`;
};

export {
  DEFAULT_LANGUAGE,
  languages,
  getLanguageFromPath,
  stripLanguagePrefix,
  localizePath,
};
